export const selectUser = state => state.userData.user;
export const selectStatus = state => state.userData.status;
export const selectIsLoggedIn = state => state.userData.isLoggedIn;
export const selectAuthError = state => state.userData.error;
